module.exports = __webpack_public_path__ + "img/ww_example.46115c4f.png";